export const BASE_URL = "https://api.asaas.com/v3"
export const SANDBOX_BASE_URL = "https://api-sandbox.asaas.com/v3"
export const ASAAS_DOCS = "https://docs.asaas.com/reference"
export function DEFAULT_HEADERS(apiKey: string) {
  return {
    "content-type": "application/json",
    accept: "application/json",
    access_token: apiKey,
    "user-agent": `NodeJS SDK`,
  }
}
